var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1051.8,450.2c-59.4-3.8-146.7,1.3-238.9,10.1c26.6-107.5,61.9-256.6,74.6-326.2 C907.7,24.1,751-15.1,716.8,70.9c-34.1,86-136.5,378-328.7,431.1c-8.8,2.5-19,7.6-19,7.6l-1.3,587.9c0,0,375.5,78.4,594.2,78.4 c110,0,184.6-19,196-123.9c15.2-140.3,32.9-317.3,40.4-421C1208.6,499.5,1168.2,457.8,1051.8,450.2L1051.8,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.8,465.3H63.2C27.8,465.3,0,493.2,0,528.6V1081c0,35.4,27.8,63.2,63.2,63.2l160.6,0 c35.4,0,63.2-27.8,63.2-63.2V528.6C287,493.2,257.9,465.3,223.8,465.3L223.8,465.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiked);
export default __webpack_public_path__ + "static/media/liked.624f67e1fef47ba6432927bc843e80df.svg";
export { ForwardRef as ReactComponent };